export interface OnboardingV1RecommendationReturns {
  readonly allTimeReturnPct: number | null;
  readonly oneYearReturnPct: number | null;
}

export type OnboardingV1RecommendationReturnDisplay =
  | { readonly period: "one_year"; readonly returnPct: number }
  | { readonly period: "all_time"; readonly returnPct: number }
  | { readonly period: "unavailable"; readonly returnPct: null };

export function getOnboardingV1RecommendationReturnDisplay(
  returns: OnboardingV1RecommendationReturns,
): OnboardingV1RecommendationReturnDisplay {
  if (
    returns.oneYearReturnPct !== null &&
    Number.isFinite(returns.oneYearReturnPct)
  ) {
    return { period: "one_year", returnPct: returns.oneYearReturnPct };
  }

  if (
    returns.allTimeReturnPct !== null &&
    Number.isFinite(returns.allTimeReturnPct)
  ) {
    return { period: "all_time", returnPct: returns.allTimeReturnPct };
  }

  return { period: "unavailable", returnPct: null };
}
